"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// styles
require("./styles/dashboard.scss");
var controllers_1 = require("./controllers");
var services_1 = require("./services");
var routes_1 = __importDefault(require("./config/routes"));
/**
 * @ngdoc module
 * @module rinca.apps.dashboard
 * @name rinca.apps.dashboard
 * @packageName rinca.apps
 * @description A module that includes the dashboard component.
 */
angular.module('rinca.apps.dashboard', ['ui.router', 'bc.Flickity'])
    .controller('DashboardController', controllers_1.DashboardController)
    .service('_dashboard', services_1.DashboardService)
    .config(routes_1.default);



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/dashboard/index.ts
// module id = 341
// module chunks = 0